import React from "react";
import { Button, Dropdown, Form } from "react-bootstrap";
import { BULK_ACTION_MENU } from "./meetingDetailsConstants";

/**
 * Top bar: report download, CSV export, meeting scope, IDF / myDoctor, bulk actions, search.
 */
export default function MeetingDetailsToolbar({
  status,
  checked,
  loader,
  allMeeting,
  showAction,
  currentStatus,
  lang,
  doctorList,
  selectedMeetingIds,
  onOpenReport,
  onSelectExportSection,
  onExportDownload,
  onAllMeetingChange,
  onIdfClick,
  onMyDoctorClick,
  onBulkStatusChange,
  onUpdateDoctor,
  filterValue,
  onFilterChange,
}) {
  return (
    <div className="table-header-section">
      <Button onClick={onOpenReport} className="download_report">
        Download Report
      </Button>
      <Dropdown>
        <Dropdown.Toggle id="dropdown-basic">Export to CSV</Dropdown.Toggle>

        <Dropdown.Menu>
          {status.map((e, i) => {
            const isSelected = checked.includes(e.type);
            return (
              <div
                className="dropdown-item"
                key={i}
                onClick={() => onSelectExportSection(e.type)}
              >
                <Form.Check
                  type="checkbox"
                  aria-label="option 1"
                  label={e.type}
                  checked={isSelected}
                />
              </div>
            );
          })}
          <div className="download-btn">
            <Button onClick={onExportDownload}>Download</Button>
          </div>
        </Dropdown.Menu>
      </Dropdown>
      <Button
        onClick={() => onAllMeetingChange(!allMeeting)}
        className="download_report"
        disabled={loader}
      >
        {allMeeting ? "Limited Meeting" : "All Meetings"}
      </Button>
      <Button
        onClick={onIdfClick}
        className="download_report min"
        style={{ minWidth: "60px" }}
      >
        IDF
      </Button>
      <Button onClick={onMyDoctorClick} className="download_report">
        myDoctor Upload
      </Button>
      {showAction && (
        <Dropdown>
          <Dropdown.Toggle id="dropdown-basic">Bulk Actions</Dropdown.Toggle>

          <Dropdown.Menu>
            {BULK_ACTION_MENU.map((e, i) => {
              return (
                <React.Fragment key={i}>
                  {e.id === "moveto" ? (
                    <Dropdown drop="end">
                      <Dropdown.Toggle
                        as="div"
                        className="dropdown-item d-flex justify-content-between align-items-center bulk-action-menu"
                        style={{
                          cursor: "pointer",
                          flexDirection: lang === "EN" ? "row" : "row-reverse",
                        }}
                      >
                        <span>{e.type}</span>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {status.map((statusItem, idx) =>
                          statusItem.type !== currentStatus ? (
                            <Dropdown.Item
                              key={idx}
                              onClick={() => onBulkStatusChange(statusItem.type)}
                            >
                              {statusItem.type}
                            </Dropdown.Item>
                          ) : null
                        )}
                      </Dropdown.Menu>
                    </Dropdown>
                  ) : e.id === "updateDoc" ? (
                    <Dropdown drop="end">
                      <Dropdown.Toggle
                        as="div"
                        className="dropdown-item d-flex justify-content-between align-items-center bulk-action-menu"
                        style={{
                          cursor: doctorList.length > 0 ? "pointer" : "not-allowed",
                          opacity: doctorList.length > 0 ? 1 : 0.6,
                          flexDirection: lang === "EN" ? "row" : "row-reverse",
                        }}
                        disabled={doctorList.length === 0}
                      >
                        <span>{e.type}</span>
                      </Dropdown.Toggle>
                      {doctorList.length > 0 && (
                        <Dropdown.Menu style={{ maxHeight: "300px", overflowY: "auto" }}>
                          {doctorList.map((doctor, idx) => (
                            <Dropdown.Item
                              key={idx}
                              onClick={() =>
                                onUpdateDoctor(doctor.doctorId, selectedMeetingIds.meetingIds)
                              }
                            >
                              <div>
                                <div style={{ fontWeight: "500" }}>{doctor.name}</div>
                                <small style={{ color: "#666" }}>{doctor.specialty}</small>
                              </div>
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      )}
                    </Dropdown>
                  ) : (
                    <Dropdown.Item className="dropdown-item" as="button">
                      <label>{e.type}</label>
                    </Dropdown.Item>
                  )}
                </React.Fragment>
              );
            })}
          </Dropdown.Menu>
        </Dropdown>
      )}
      <input
        id="filter-text-box"
        placeholder="Search"
        value={filterValue}
        onChange={onFilterChange}
        className="global-search"
        type="search"
      />
    </div>
  );
}
